<template>
	<fragment>
		<common-header
			subname="회원관리"
			name="비회원 관리"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			searchbox
			@keywordChanged="keywordChanged"
		></common-header>

		<section ref="container" class="container">
			<ctrl-filter listName="수강생 목록" @changeFilters="changeFilters"></ctrl-filter>

			<div class="container-fiuld">
				<div class="btn-group-box clearfix">
					<div class="btn-group pull-left clearfix">
						<div class="select pull-left m-r-5">
							<a class="btn round">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="22" height="20" viewBox="0 0 22 20">
									<path class="msg-i"
										d="M262.519,1266.28a0.158,0.158,0,0,0,.019.08c0,0.02.019,0.06,0.019,0.08a0.473,0.473,0,0,1,.019.08,0.3,0.3,0,0,1,.038.08c0.019,0.02.019,0.04,0.038,0.06a0.107,0.107,0,0,1,.038.06l0.057,0.06,0.019,0.02a0.019,0.019,0,0,1,.019.02,0.447,0.447,0,0,0,.209.12,0.037,0.037,0,0,1,.038.02,0.91,0.91,0,0,0,.228.04h20.5a0.91,0.91,0,0,0,.228-0.04,0.037,0.037,0,0,0,.038-0.02,2.043,2.043,0,0,0,.209-0.12,0.019,0.019,0,0,0,.019-0.02l0.019-.02,0.057-.06a0.107,0.107,0,0,0,.038-0.06c0.019-.02.019-0.04,0.038-0.06a0.3,0.3,0,0,0,.038-0.08,0.1,0.1,0,0,0,.019-0.08c0-.02.019-0.06,0.019-0.08a0.473,0.473,0,0,0,.019-0.08v-18.46a0.792,0.792,0,0,0-.779-0.82H263.279a0.792,0.792,0,0,0-.779.82v18.38A0.1,0.1,0,0,1,262.519,1266.28Zm2.432-.94,5.756-7.25,2.394,1.76a0.752,0.752,0,0,0,.874,0l2.394-1.76,5.756,7.25H264.951Zm18.067-1.44-5.377-6.75,5.358-3.94v10.69h0.019Zm-18.96-15.26H283v2.58l-9.461,6.95-9.48-6.95v-2.58Zm0,4.57,5.357,3.94-5.357,6.75v-10.69Z"
										transform="translate(-262.5 -1247)" />
								</svg> 전자우편 보내기
							</a>
							<ul class="option">
								<li>
									<a @click="onMailForm(false)">검색된 모든 회원</a>
								</li>
								<li>
									<a @click="onMailForm(true)">선택된 회원</a>
								</li>
							</ul>
						</div>
						<div class="select pull-left m-r-5">
							<a class="btn round">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="20" height="20"
									viewBox="0 0 20 20">
									<path class="sms-i"
										d="M386.428,1249.93a10,10,0,0,1,14.807,13.41,3.719,3.719,0,0,0,1.575,1.82,0.933,0.933,0,0,1-.268,1.76,5.3,5.3,0,0,1-.708.05h0a6.478,6.478,0,0,1-3.6-1.16A10,10,0,0,1,386.428,1249.93Zm0.8,13.34a8.909,8.909,0,0,0,10.763,1.38,0.59,0.59,0,0,1,.285-0.08,0.621,0.621,0,0,1,.348.11,5.414,5.414,0,0,0,3.138,1.16,5.789,5.789,0,0,1-1.714-2.37,0.561,0.561,0,0,1,.1-0.6A8.871,8.871,0,1,0,387.229,1263.27Zm2.082-9.57h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1253.7Zm0,2.73h8.38a0.569,0.569,0,0,1,.565.57,0.561,0.561,0,0,1-.565.56h-8.38a0.562,0.562,0,0,1-.566-0.56A0.573,0.573,0,0,1,389.311,1256.43Zm0,2.74h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1259.17Z"
										transform="translate(-383.5 -1247)" />
								</svg> 문자 보내기
							</a>
							<ul class="option">
								<li>
									<a @click="onSMSForm(false)">검색된 모든 회원</a>
								</li>
								<li>
									<a @click="onSMSForm(true)">선택된 회원</a>
								</li>
							</ul>
						</div>
						<!--
						<div class="select pull-left m-r-5">
							<a class="btn round">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="20" height="20"
									viewBox="0 0 20 20">
									<path class="sms-i"
										d="M386.428,1249.93a10,10,0,0,1,14.807,13.41,3.719,3.719,0,0,0,1.575,1.82,0.933,0.933,0,0,1-.268,1.76,5.3,5.3,0,0,1-.708.05h0a6.478,6.478,0,0,1-3.6-1.16A10,10,0,0,1,386.428,1249.93Zm0.8,13.34a8.909,8.909,0,0,0,10.763,1.38,0.59,0.59,0,0,1,.285-0.08,0.621,0.621,0,0,1,.348.11,5.414,5.414,0,0,0,3.138,1.16,5.789,5.789,0,0,1-1.714-2.37,0.561,0.561,0,0,1,.1-0.6A8.871,8.871,0,1,0,387.229,1263.27Zm2.082-9.57h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1253.7Zm0,2.73h8.38a0.569,0.569,0,0,1,.565.57,0.561,0.561,0,0,1-.565.56h-8.38a0.562,0.562,0,0,1-.566-0.56A0.573,0.573,0,0,1,389.311,1256.43Zm0,2.74h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1259.17Z"
										transform="translate(-383.5 -1247)" />
								</svg> 쪽지 보내기
							</a>
							<ul class="option">
								<li>
									<a @click="onNoteForm(false)">검색된 모든 회원</a>
								</li>
								<li>
									<a @click="onNoteForm(true)">선택된 회원</a>
								</li>
							</ul>
						</div>
						-->
						<div class="select pull-left m-r-5">
							<a class="btn btn-red round" @click="onIntegration">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="20" height="20" viewBox="0 0 20 20">
									<path id="Integration" class="integration"
										d="M520.385,277H509.6a1.613,1.613,0,0,0-1.616,1.606v4.344h-4.369A1.612,1.612,0,0,0,502,284.556v10.727a1.612,1.612,0,0,0,1.615,1.606h8.113c-0.01-.049-0.022-0.1-0.028-0.146l-0.222-1.89h-7.431v-9.867h3.937v4.345a1.613,1.613,0,0,0,1.616,1.607h1.421l-0.239-2.036h-0.75v-3.916h3.938v1.229l2.047,1v-2.657a1.613,1.613,0,0,0-1.616-1.606h-4.37v-3.914h9.922V288.9h-0.472l1.991,0.971a1.826,1.826,0,0,1,.33.213,1.581,1.581,0,0,0,.2-0.755V278.606A1.612,1.612,0,0,0,520.385,277Zm0.484,14.09-8.194-3.995a0.475,0.475,0,0,0-.479.037,0.468,0.468,0,0,0-.2.437l1.055,9.017a0.467,0.467,0,0,0,.338.395,0.45,0.45,0,0,0,.13.019,0.472,0.472,0,0,0,.367-0.176l2.757-3.433,4.169-1.438A0.467,0.467,0,0,0,520.869,291.09Z"
										transform="translate(-502 -277)" />
								</svg> 회원통합
							</a>
						</div>
					</div>

					<div class="btn-group pull-right clearfix">
						<select class="form-control round pull-left m-r-5" v-model="pageSize" @change="pageSize=parseInt(pageSize);getMemberData">
							<option value="10">10개씩 보기</option>
							<option value="30">30개씩 보기</option>
							<option value="50">50개씩 보기</option>
						</select>
						<select class="form-control round pull-left m-r-5" v-model="orderBy" @change="getMemberData">
							<option value="MBER_NAME ASC">이름순</option>
							<option value="REG_DATE ASC">가입일 과거순</option>
							<option value="REG_DATE DESC">가입일 최신순</option>
						</select>
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" @click="download">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 전체 다운로드
							</a>
						</div>
					</div>
				</div>

				<table class="table2 table-hover m-t-10 text-center">
					<thead>
						<tr class="bg-lightgray">
							<th>
								<input id="table-allcheck" class="checkbox" type="checkbox"
									:checked="isCheckedAll" @change="checkAllUsers()">
								<label for="table-allcheck">체크버튼</label>
							</th>
							<th>이름</th>
							<th>아이디</th>
							<th>연락처</th>
							<th>가입경로</th>
							<th>관리</th>
						</tr>
					</thead>
					<tbody v-for="(member, memberIndex) in members" :key="hash(member)">
						<tr class="margin">
							<td colspan="7"></td>
						</tr>
						<tr :class="selectedMember == member ? 'on' : ''" @click="selectMemberData(member)">
							<td>
								<input :id="`table-check2-${memberIndex}`" class="checkbox"
									v-model="member.isChecked" type="checkbox">
								<label :for="`table-check2-${memberIndex}`">체크버튼</label>
							</td>
							<td>
								{{ member.mberName }}
							</td>
							<td>
								<!--{{ member.mberId }}-->
								비회원
							</td>
							<td class="text-left">
								{{ member.email }}<br>
								{{ member.mobileNum }}
							</td>
							<td>비회원</td>
							<td>
								<router-link :to="`/users/detail/${member.mberId}`"  class="more m-r-10">상세</router-link>
								<router-link :to="`/users/detail/${member.mberId}/modify`" class="modify m-r-10">수정</router-link>
								<a class="del" @click="deleteMemberData(memberIndex)">삭제</a>
							</td>
						</tr>
					</tbody>
				</table>

				<ctrl-pagination :currentPage="offset / pageSize + 1"
					:pageSize="pageSize" :totalCount="totalCount"
					:key="hash({pageSize, offset, totalCount})"
					@pageChanged="onPageChanged"></ctrl-pagination>
			</div>

			<ctrl-member-summary v-if="selectedMember" ref="scrollableSummary" :member="selectedMember" @onSms="onSms(selectedMember)" @onEmail="onEmail(selectedMember)"></ctrl-member-summary>
		</section>

		<common-footer></common-footer>

		<modal-user-unify :config="modals.ModalUserUnify" @close="modals.ModalUserUnify.show=false;" :key="hash(modals.ModalUserUnify)" @refresh="onRefresh" @onDone="onDone" @onConfirm="onConfirm"></modal-user-unify>
		<modal-user-register-excel :config="modals.ModalUserRegisterExcel" @close="modals.ModalUserRegisterExcel.show=false;" :key="hash(modals.ModalUserRegisterExcel)" @refresh="onRefresh" @onDone="onDone" @onConfirm="onConfirm"></modal-user-register-excel>
		<modal-email :config="modals.ModalEmail" @close="modals.ModalEmail.show=false;" :key="hash(modals.ModalEmail)" @onDone="onDone" @onConfirm="onConfirm"></modal-email>
		<modal-note :config="modals.ModalNote" @close="modals.ModalNote.show=false;" :key="hash(modals.ModalNote)" @onDone="onDone" @onConfirm="onConfirm"></modal-note>
		<modal-sms :config="modals.ModalSms" @close="modals.ModalSms.show=false;" :key="hash(modals.ModalSms)" @onDone="onDone" @onConfirm="onConfirm"></modal-sms>
		<modal-user-register :config="modals.ModalUserRegister" @close="modals.ModalUserRegister.show=false;"
			:key="hash(modals.ModalUserRegister)" @refresh="onRefresh"></modal-user-register>
		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import fnUserList from '../mixins/fnUserList'
import fnScrollable from '../mixins/fnScrollable'
import axios from 'axios'
import server from '../statics/server.js'

import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import ModalUserRegister from '../modals/ModalUserRegister.vue'
import ModalEmail from '../modals/ModalEmail.vue'
import ModalNote from '../modals/ModalNote.vue'
import ModalSms from '../modals/ModalSms.vue'
import ModalUserUnify from '../modals/ModalUserUnify.vue'
import ModalUserRegisterExcel from '../modals/ModalUserRegisterExcel.vue'

import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CtrlFilter from '../components/CtrlFilter.vue'
import CtrlPagination from '../components/CtrlPagination.vue'
import CtrlMemberSummary from '../components/CtrlMemberSummary.vue'

export default {
	// 컴포넌트명
	name: "ViewUserStudentList",
	mixins: [fnScrollable, fnAdjustHeight, fnUserList],

	// 이 컴포넌트가 DOM에 마운트될 때,
	mounted: function() {
		// 맴버 데이터 가져오기
		this.getMemberData();
	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
				ModalUserRegister: ModalUserRegister.default(),
				ModalEmail: ModalEmail.default(),
				ModalNote: ModalNote.default(),
				ModalSms: ModalSms.default(),
				ModalUserUnify: ModalUserUnify.default(),
				ModalUserRegisterExcel: ModalUserRegisterExcel.default()
			},
			menus: [ // 서브메뉴
				// {name:'수강생 관리',link:"/users/students",selected:false},
				// {name:'강사 관리',link:"/users/teachers",selected:false},
				{name:'관리자 관리',link:"/users/admins",selected:false},
				{name:'비회원 관리',link:"/users/sys",selected:true},
			],
			buttons: [ // 헤더버튼
				{name:'회원 등록',fn:this.onUserRegister},
				{name:'일괄 등록',fn:this.onUserRegisterExcel}
			],
			members: [], // 검색된 모든 회원 목록
			selectedMember: null, // 현재 선택된 회원

			// 검색 조건
			offset: 0,
			keyword: "",
			orderBy: "REG_DATE DESC",
			pageSize: 10,
			filterList: [],

			// 필터링된 회원수
			totalCount: 0
		}
	},

	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		CommonHeader,
		CommonFooter,
		CtrlFilter,
		CtrlPagination,
		CtrlMemberSummary,
		ModalUserRegister,
		ModalConfirm,
		ModalAlert,
		ModalUserRegisterExcel
	},

	// 이 컴포넌트에서 구현되어야 할 기능
	methods: {
		// 유저 데이터 가져오는 메소드
		getMemberData: async function() {
			const { offset, keyword, pageSize, orderBy, filterList } = this;
			try {
				const { data } = await axios.post(`${server.addr()}${server.api.MBER}`, {
					offset, keyword, pageSize, orderBy, filterList, adminEnable:0, instEnable:0, sysEnable:true
				});
				this.members = data.list;
				this.totalCount = parseInt(data.filtered);
			} catch(e) {
				this.modals.ModalAlert.msg = "통신에러! 잠시 후 다시 시도해주세요.";
				this.modals.ModalAlert.show = true;
			}
		},
		keywordChanged: function(keyword) {
			this.keyword = keyword;
			this.getMemberData();
		},
		download: function() {
			const { keyword, orderBy, filterList } = this;
			axios.post(server.addr()+server.api.MBER_EXCEL, {keyword, orderBy, filterList, sysEnable:true}).then( response => {
				window.open( "/download/"+response.data, "", "" );
			})
		}
	},
}
</script>



<style scoped>
.msg-i {
	fill: #999;
	fill-rule: evenodd;
}
.btn-group .btn:hover .msg-i {
	fill: #fff;
	fill-rule: evenodd;
}
.sms-i {
	fill: #999;
	fill-rule: evenodd;
}
.btn-group .btn:hover .sms-i {
	fill: #fff;
	fill-rule: evenodd;
}
.integration {
	fill: #fff;
	fill-rule: evenodd;
}
.btn-group .btn:hover .integration {
	fill: #fff;
	fill-rule: evenodd;
}
</style>